import { useContext, useEffect, useState } from 'react'
import "../payment-status/paymentStatus.css"
import "../checkout-page/checkOutPage.css"
import { LoadingSpinner } from '../../components/mini-components/mini-components'
import Lottie from "lottie-react";
import failed from "../../assets/lottie/failed.json";
import success from "../../assets/lottie/success.json";
import { useLocation, useNavigate } from 'react-router-dom';
import { successToast , errorToast } from '../../functions/mini_func';
import CartContext from '../../context/cart_context';
import { ref , get , off , onValue   } from 'firebase/database';
import { doc as fsDoc, updateDoc } from 'firebase/firestore';
import { db, firestoreDB } from '../../config/firebase_config';

const PayuPaymentStatus = () => {

    const navigate = useNavigate();
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const orderId = queryParams.get('orderId');
    const status = queryParams.get('status');
    const date = queryParams.get('date');
    const amount = queryParams.get('amount');
    const errorMsg = queryParams.get('error');
    const {resetCart } = useContext(CartContext);


    const retriveOrderData = () => {
        const userData = JSON.parse(localStorage.getItem("user"));
        const dabaseRef = ref(db , `TrackPayments/${userData.phoneNo}/${orderId}` );
        get(dabaseRef).then(
           async (snapshot) => {
              console.log(snapshot);
                const data = snapshot.val();
                  if(!data){
                    return ;
                  }
                console.log(data);
                const orderRef = ref(db, `TrackPayments/${userData.phoneNo}/${orderId}`);
                 if(data.status == "success" ){
                
                    navigate(`/orderpage?orderID=${data.dbID}`,{replace:true});
                    resetCart();
                    localStorage.removeItem("paytm");
                    localStorage.removeItem("razorOrderId");
                 }else if(data.status == "failure"){
                
                    errorToast("Transaction failed" , "Payment failed or dismissed . please try again" );
                    localStorage.removeItem("razorOrderId");
                    localStorage.removeItem("paytm");
                 }else if(data.status == "init"){
                    const listeningDurationInMilliseconds = 5 * 60 * 1000;
                    const currentTime = Date.now();
                    const timeDifferenceInSeconds = Math.floor((currentTime - parseFloat(orderId)) / 1000);
                
                  if (timeDifferenceInSeconds < 300) {
                    const timer = setTimeout(() => {
                      const listener = onValue(orderRef, async(snapshot) => {

                        const data = snapshot.val();
                        if (data && data.status === "success") {
                          navigate(`/orderpage?orderID=${data.dbID}`,{replace:true});
                          resetCart();
                          localStorage.removeItem("razorOrderId");
                          localStorage.removeItem("paytm");

                        } else if ( data && data.status === "failure") {

                          errorToast("Transaction failed", "Payment failed or dismissed. Please try again");
                          localStorage.removeItem("razorOrderId");
                          localStorage.removeItem("paytm");
                          
                          // remove(orderRef);
                        }
                        console.log(data);
                        if(listener != null){
                          off(orderRef, 'value', listener);
                        }
                        clearTimeout(timer);
                        // remove(orderRef);
                      });
    
                      setTimeout(() => {
                        if(listener != null){
                          off(orderRef, 'value', listener);
                        }
                      }, listeningDurationInMilliseconds - (timeDifferenceInSeconds));
    
    
                    }, listeningDurationInMilliseconds - (timeDifferenceInSeconds));
                    
                  }else{
                    localStorage.removeItem("razorOrderId");
                    localStorage.removeItem("paytm");
                    // remove(orderRef);
                    
                  }
                  
                 }else{
                  localStorage.removeItem("razorOrderId");
                  localStorage.removeItem("paytm");
                  // remove(orderRef);
                  
                 }
            } 
        ).catch((e) => {
              console.log(e);
        });
      }

    useEffect(() => {

      if(status == "success"){
        successToast("Transaction Succesful" , "Payment completed Succesfully . please wait while we are checking order Status");
        retriveOrderData();
      }

    }, [])

    // Table bill payments (from /tableOrderBooking/:id) stash the bill id in
    // localStorage before redirecting to PayU. On return, flip the bill's
    // paymentStatus so the vendor and the bill page reflect it.
    useEffect(() => {
      const billId = localStorage.getItem("pendingTableBillId");
      if (!billId) return;

      if (status == "success") {
        updateDoc(fsDoc(firestoreDB, "tableOrderBills", billId), {
          paymentStatus: "paid",
          paidAt: new Date().toISOString(),
        })
          .catch((e) => console.log("Failed to update bill status", e))
          .finally(() => localStorage.removeItem("pendingTableBillId"));
      } else if (status && status != "success") {
        // Payment failed/cancelled — clear so it isn't marked paid later.
        localStorage.removeItem("pendingTableBillId");
      }
    }, [])
    
  return (
    <div className='status-container'>
        <Lottie animationData={ status == "success" ? success : failed}  className="failed-lottie"  />
        <h3 className="process-heading">{ status == "success" ?  "Transaction Succesful"  :  "Payment Failed"}</h3>
          {
            amount &&  <h2>{"\u{20B9}\t"}{amount}</h2>
          }
          {
            <p className='trns-data'> OrderID : {orderId}</p>
          }
          {
            status != "success" &&  <p className='trns-data'>{errorMsg}</p>
          }
          {
            orderId &&    <p  style={{fontSize : "12px"}} className='trns-data'>Transaction ID : { orderId}</p>
          }
          {
            date &&  <p className='trns-data'> Date : {date.split(" ")[0]}</p>
          }
          {
              date &&  <p className='trns-data'>Time : { date.split(" ")[1]}</p>
          }
        {
          status != "success" && <button className = "back-btn" onClick={() =>  navigate(-1) } >Go Back</button>
        }
    </div>
  )

}

export default PayuPaymentStatus
